import { SxProps, Theme } from '@mui/material';

export type OptionWithId = {
  id: string;
  name: string;
};

export type SelectAllOption = {
  id: '__SELECT_ALL__';
  name: string;
};

export type VyMultipleAutoCompleteProps<OptionType extends OptionWithId> = {
  options: OptionType[];
  value: OptionType[];
  onChange: (newValue: OptionType[]) => void;
  getOptionLabel: (option: OptionType) => string;
  label?: string;
  placeholder?: string;
  showSelectAll?: boolean;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
  disabled?: boolean;
  textFieldProps?: object;
};

export const SELECT_ALL_OPTION: SelectAllOption = {
  id: '__SELECT_ALL__',
  name: 'Select all',
};
